module.exports = __webpack_public_path__ + "static/media/Resume.43dd0eb6.pdf";